import { z } from 'zod';

/**
 * O tema de um caso entregue a um humano — o eixo que, junto das horas até o
 * próximo trecho da viagem, decide a prioridade do card:
 * - `disruption`: cancelamento, atraso, perda de conexão, alteração de malha, no-show;
 * - `travel_ops`: check-in, bagagem, assento, documento/visto, embarque, hotel na chegada;
 * - `change_request`: o cliente quer alterar ou cancelar por vontade própria;
 * - `admin`: reembolso, nota, fatura, política, cadastro;
 * - `other`: o resto.
 */
export const HandoffTopicSchema = z.enum([
  'disruption',
  'travel_ops',
  'change_request',
  'admin',
  'other',
]);

export type HandoffTopic = z.infer<typeof HandoffTopicSchema>;
